import type { AlpineComponent } from 'alpinejs';

export const sidebar: AlpineComponent = {
	isOpen: false,

	open() {
		this.isOpen = true;
	},

	close() {
		this.isOpen = false;
	}
};
